import { useAppointmentProposalSurveyOptions } from '@airship-platform/airship-patterns';
import {
  EmptyState,
  LoadingButton,
} from '@airship-platform/jam-web/components';
import { Link, useNavigate } from 'react-router';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import { SectionWrapper } from '../../../patterns';
import CustomerExperienceSection, {
  CustomerExperienceInputs,
} from './sections/CustomerExperienceSection';

const FORM_ID = 'proposalCustomerExperienceForm';

const CustomerExperiencePage: React.FC = () => {
  const navigate = useNavigate();
  const { customerExperienceOptions } = useAppointmentProposalSurveyOptions();
  const { currentProposal, isLoading, updateAppointmentProposal } =
    useAppointmentProposals();

  if (!currentProposal) {
    return (
      <EmptyState
        title="Appointment not found"
        subtitle="Oops! The requested appointment was not found."
      />
    );
  }

  const onSubmit = (customerExperience: CustomerExperienceInputs) =>
    updateAppointmentProposal(
      currentProposal.appointmentId,
      currentProposal.appointmentProposalId,
      { customerExperience }
    ).then(() => navigate(-1));

  return (
    <SectionWrapper
      maxWidth={'28rem'}
      width={'100%'}
      header="Capture your customer's experience at home"
      subheader="Select options that fit the homeowner's current experience and their priorities."
      actionsButtons={{
        left: {
          color: 'softGold',
          component: Link,
          to: '../service-menu',
          label: 'Cancel',
        },
        right: {
          type: 'submit',
          component: LoadingButton,
          form: FORM_ID,
          label: 'Save',
          loading: isLoading,
          disabled: isLoading,
        },
      }}
    >
      <CustomerExperienceSection
        formId={FORM_ID}
        options={customerExperienceOptions}
        defaultValues={currentProposal.customerExperience}
        onSubmit={onSubmit}
      />
    </SectionWrapper>
  );
};

export default CustomerExperiencePage;
